import { gateway } from "../../../gateway"
import { ETimePeriods } from "../enums/timesheets.enum";

export const getWorkforceAnalytics = async (period: ETimePeriods) => {
    const response = await gateway.get(`/workforce/analytics?period=${period}`);

    return response.data?.data || response.data;
}